import {EntityType, WorkSite, WorkSiteForm} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {WorkSites_Read} from "../util/access/Permission";

interface WorkSiteStore extends EntityStore<WorkSite[]> {
    updateWorkSite: (site: WorkSite, patch: WorkSiteForm) => Promise<WorkSite>,
}

export const useWorkSiteStore = create<WorkSiteStore>()(
    arrayResource<WorkSite, WorkSiteStore>(EntityType.WorkSites, builder => {
        const rest = builder.crud<WorkSiteForm>('/work-sites', 'id');

        return {
            remoteValue: builder.all(WorkSites_Read, () => rest.getAll()),
            updateWorkSite: builder.updateAndPatch<WorkSiteForm>(rest),
        };
    })
);

startEntityStore(useWorkSiteStore);
